import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AlertStateChange } from "@app2/clients/types/alert-typedefs";
import { ModalService } from "@app2/shared/modal/modal.service";
import { FlagFraudFormModalComponent } from "@app2/alert/alert-inbox/flag-fraud-form-modal.component";

@Component({
    selector: `flag-fraud-button`,
    template: `
        <button class="action-icon button link secondary borderless"
                [ngClass]="{'disabled-button': loading}"
                [disabled]="loading"
                test-class="state-change-button-FRAUD"
                [matTooltip]="(allForTrigger ? 'FLAG_FRAUD_30D' : 'FLAG_FRAUD') | localize"
                (click)="showFraudFlagModal()">
            <img *ngIf="allForTrigger && shouldShowBulkLines"
                 class="bulk-lines"
                 src="assets/icons/alert-action-bulk-lines.svg"/>
            <svg-icon src="assets/icons/fraudFlag.svg" class="flag-fraud"></svg-icon>
        </button>
    `,
})
export class FlagFraudButtonComponent {
    @Input() currentState: string;
    @Input() currentTriggerName: string;
    @Input() loading: boolean;
    @Input() allForTrigger: boolean;
    @Input() shouldShowBulkLines: boolean;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onSubmit = new EventEmitter<AlertStateChange>();


    constructor(private modalService: ModalService) {
    }


    showFraudFlagModal() {
        this.modalService
            .open(FlagFraudFormModalComponent,
                { currentState: this.currentState, currentTriggerName: this.currentTriggerName })
            .afterClosedWithResult()
            .subscribe((stateChange: AlertStateChange) => {
                this.onSubmit.emit(stateChange);
            });
    }
}
